import { Resume } from '@sr/types';
import copy from 'clipboard-copy';
import React, { useState } from 'react';
import { Button, CopyIcon, Text } from '../../ui';
import { getPublicResumeUrl } from './Share';

const CopyResumeUrl = ({ resume }: { resume: Resume }) => {
  const [success, setSuccess] = useState(false);

  function copyUrl() {
    copy(getPublicResumeUrl(resume)).then(() => setSuccess(true));
    window.setTimeout(() => setSuccess(false), 1000 * 10);
  }

  return (
    <Button
      onClick={copyUrl}
      variant="link"
      data-testid="copy-resume-url"
      ml={-4}
      py={2}
    >
      <CopyIcon size={24} mr={2} />
      <Text color="black" pl={2}>
        {success ? 'Copied!' : 'Copy resume link'}
      </Text>
    </Button>
  );
};

export default CopyResumeUrl;
